import React from 'react'
import { I18n } from 'react-redux-i18n';
import EntityGeneralForm from "../../../baseApp/entities/components/fields/EntityGeneralForm";
import Alert from '../../../baseApp/shared/components/alerts/Alert';
import MeetingRoomSubForm from './../../otherEntities/components/MeetingRoomSubForm';
import MeetingRoomViewForm from "./MeetingRoomsViewForm";
import { appModules } from '../../../baseApp/roles/components/UserHasPermission';
import FormButtons from '../../../baseApp/shared/components/others/formButtons/FormButtons';

const MeetingRoomsForm = ({
    meetingRoomId,
    meetingRoomFormData: {
        name,
        parent,
        subFormData = {},
    },
    meetingRoomData: {
        operationTimeStart,
        operationTimeEnd,
        email,
        capacity,
        hasQuickBook
    },
    alert,
    editMode,
    createMode,
    viewMode,
    entityList,
    entityLastReadings,
    providerList,
    eventsForCalendar,
    handleFieldChange,
    handleOnFieldBlur,
    handleSubFormFieldChange,
    handleSubmitClick,
    handleBackClick,
    handleEditClick,
    handleDeleteClick,
}) => {
   
    return (
        createMode || editMode ? (
            <div className="form-container">
                <div className="form">
                    <Alert
                        {...alert}
                    />
                    <div className="header">
                        {buildHeader(createMode, editMode, viewMode)}
                    </div>
                    <div className="fields">
                        <EntityGeneralForm
                            name={name}
                            parent={parent}
                            entityList={entityList}
                            viewMode={viewMode}
                            editMode={editMode}
                            createMode={createMode}
                            handleFieldChange={handleFieldChange}
                            handleOnFieldBlur={handleOnFieldBlur}
                        />
                        <MeetingRoomSubForm
                            {...subFormData}
                            providerList={providerList}
                            handleFieldChange={handleSubFormFieldChange}
                            viewMode={viewMode}
                            createMode={createMode}
                            editMode={editMode}
                        />
                        {(createMode || editMode) &&
                            <div className="buttons">
                                <button
                                    className=" mt-3 btn btn-primary"
                                    onClick={handleSubmitClick}
                                >
                                    {I18n.t("forms.save")}
                                </button>
                            </div>
                        }
                    </div>
                </div>
                <div className="form-options">
                    <FormButtons
                        editMode={editMode}
                        viewMode={viewMode}
                        handleBackClick={handleBackClick}
                        handleEditClick={handleEditClick}
                        handleDeleteClick={handleDeleteClick}
                        appModule={appModules.ENTITY}
                    />
                </div>
            </div>
        ) : (
                <MeetingRoomViewForm
                    name={name}
                    parent={parent}
                    meetingRoomId={meetingRoomId}
                    status={subFormData.status}
                    entityLastReadings={entityLastReadings}
                    eventsForCalendar={eventsForCalendar}
                    alert={alert}
                    editMode={editMode}
                    createMode={createMode}
                    viewMode={viewMode}
                    handleFieldChange={handleFieldChange}
                    handleOnFieldBlur={handleOnFieldBlur}
                    handleSubmitClick={handleSubmitClick}
                    handleBackClick={handleBackClick}
                    handleEditClick={handleEditClick}
                    handleDeleteClick={handleDeleteClick}
                    operationTimeStart={operationTimeStart}
                    operationTimeEnd={operationTimeEnd}
                    email={email}
                    capacity={capacity}
                    hasQuickBook = {hasQuickBook}
                />
            )
    )
};

function buildHeader(createMode, editMode) {
    return createMode ?
        I18n.t("meetingRooms.form.headers.create") :
        editMode ?
            I18n.t("meetingRooms.form.headers.edit") :
            I18n.t("meetingRooms.form.headers.view");
}

export default MeetingRoomsForm;